<div class="container" [formGroup]="rejectCommentForm">
  <ng-container *ngIf="data.comments.length === 1">
    <h1 class="comment-title" mat-dialog-title>{{ 'COMMENTS.SEARCH.MSG.MODAL_REJECT_TITLE' | translate }}</h1>
    <mat-card class="comment-content">{{ data.comments[0].content }}</mat-card>
  </ng-container>

  <ng-container *ngIf="data.comments.length > 1">
    <h1 class="comment-title" mat-dialog-title>{{ 'COMMENTS.SEARCH.MSG.MODAL_REJECT_TITLE_PLURAL' | translate }}</h1>
    <mat-card class="comment-multiple">
      {{ 'COMMENTS.SEARCH.MSG.MODAL_REJECT_BATCH' | translate : { number: data.comments.length } }}
    </mat-card>
  </ng-container>

  <div class="reason">
    <span>{{ 'COMMENTS.SEARCH.MSG.MODAL_REJECT_REASON' | translate }}</span>
    <div>
      <mat-form-field class="reason-select">
        <mat-label></mat-label>
        <mat-select formControlName="reason">
          <mat-option *ngFor="let reason of reasons" [value]="reason.key">
            {{ reason.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button mat-button class="btn-warn" (click)="onCancel()">{{ 'CANCEL' | translate }}</button>
    <button mat-button class="btn-cancel" (click)="rejectComments()">{{ 'COMMENTS.SEARCH.BTN.BATCH_REJECT' | translate }}</button>
  </mat-dialog-actions>
</div>
